import Vue from 'vue'
import Router from 'vue-router'
//import store from '@/store'

// mixen routers
import AuthRoutes from '@/router/modules/auth'
import ErrorsRoutes from '@/router/modules/errors'
import HomeRoutes from "@/router/modules/home";
import CartRoutes from "@/router/modules/carts";
import MenuRoutes from '@/router/modules/menu'
import ProjectRoutes from '@/router/modules/projects'
import ProjectNomination from '@/router/modules/projectNomination'
import VolunteerRequest from '@/router/modules/volunteerRequest'
import DonationVouchers from '@/router/modules/donationVouchers'
import NewsRoutes from '@/router/modules/news'
import AboutRoutes from '@/router/modules/about'
import ContactRoutes from '@/router/modules/contacts'
import PagesRoutes from '@/router/modules/pages'
import AchievementsRoutes from '@/router/modules/achievements'
import ShareRedirectRoutes from '@/router/modules/shareRedirect'

var allRoutes = [];
allRoutes = allRoutes.concat(
    AuthRoutes,
    HomeRoutes,
    CartRoutes,
    MenuRoutes,
    ProjectRoutes,
    ProjectNomination,
    VolunteerRequest,
    DonationVouchers,
    NewsRoutes,
    AboutRoutes,
    AchievementsRoutes,
    ContactRoutes,
    PagesRoutes,
    ShareRedirectRoutes,
    ErrorsRoutes,
)

Vue.use(Router)
export default new Router({
    mode: 'history',
    base: '/',
    fallback: true,
    routes: allRoutes,
    scrollBehavior() {
        if (document.getElementById('app')) {
            document.getElementById('app').scrollIntoView({ behavior: 'smooth' });
        }
    }
})

